<template>
  <div class="chat__more--wrapper">
    <v-btn icon small class="chat__more--btn" @click.stop="openMenu">
      <v-icon>bhi-dots-vertical</v-icon>
    </v-btn>
    <v-menu
      rounded
      absolute
      offset-x
      transition="false"
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
    >
      <v-btn
        link
        dense
        @click="onPressArchive($event, chat)"
        class="chat__more--menu"
      >
        <v-list-item-icon>
          <v-icon>bhi-folder-move-filled</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ !archived ? 'Archive' : 'Unarchive' }}
          </v-list-item-title>
        </v-list-item-content>
      </v-btn>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'ChatMoreMenu',
  props: {
    archived: {
      type: Boolean,
      default: false,
    },
    chat: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      x: 0,
      y: 0,
      showMenu: false,
    }
  },
  methods: {
    openMenu(e) {
      e.preventDefault()
      e.stopPropagation()
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    closeMenu() {
      this.showMenu = false
    },
    onPressArchive(e, chat) {
      e.preventDefault()
      this.$emit('setChatArchive', chat)
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.chat {
  &__more {
    width: 32px;
    flex-shrink: 0;
    text-align: center;
    position: absolute;
    top: 4px;
    right: 0;
    opacity: 0;
    -webkit-transition-duration: 150ms;
    -moz-transition-duration: 150ms;
    -ms-transition-duration: 150ms;
    -o-transition-duration: 150ms;
    transition-duration: 150ms;

    &--btn {
      z-index: 99;
      .v-ripple__container {
        border-radius: 50% !important;
        left: 0 !important;
      }
    }

    &--menu {
      padding: 25px !important;
      .v-list-item__icon {
        margin-right: 12px !important;
        text-align: center;
        display: block;
        .v-icon {
          color: $bh-blue;
        }
      }
      .v-list-item__title {
        font-weight: bold;
        font-size: 1rem;
        color: $bh-blue;
      }
    }

    &--menu-context {
      background-color: $bh-new-gray;
    }
    &--menu-item {
      padding: 0 12px;
      transition: background-color 0.3s ease-in;
      cursor: pointer;
      &.v-list-item {
        &--link:before {
          background-color: inherit;
        }
      }
      &:hover {
        background-color: $bh-white;
      }
      &__wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 0 24px 0 40px;
      }
      &__title {
        font-size: 1rem;
        font-weight: 700;
        color: $bh-gray--1;
      }
      &__time {
        font-size: 1rem;
        font-weight: 400;
        color: $bh-gray--2;
      }
    }
  }
}
</style>
